export interface Projekt {
  id: number;
  name: string;
}

export interface Mitarbeiter {
  id: number;
  name: string;
}

export interface Zeiteintrag {
  id: number;
  date: string;
  projectId: number;
  projectName: string;
  startTime: string;
  endTime: string;
  breakDuration: number;
  hours: number;
  description: string;
  userId: number;
  userName: string;
  created_at: string;
  createdByUserId?: number;
  createdByUserName: string;
}

/** Nutzlast für Anlegen und Ändern eines Eintrags. */
export interface ZeiteintragEingabe {
  date: string;
  projectId: number;
  startTime: string;
  endTime: string;
  breakDuration: number;
  description: string;
  /** Nur für Admin und Projektleiter: Eintrag für einen anderen Mitarbeiter. */
  forUserId?: number;
  /** Eine gemeldete Überschneidung bewusst akzeptieren. */
  ueberlappungIgnorieren?: boolean;
}

/** Vom Backend gemeldete Überschneidung (HTTP 409). */
export interface Ueberlappung {
  id: number;
  projektName: string;
  startTime: string | null;
  endTime: string | null;
}

export type SortierFeld = 'date' | 'hours';

export interface SortierZustand {
  feld: SortierFeld;
  richtung: 'asc' | 'desc';
}

export interface FilterZustand {
  projectId: string;
  userId: string;
  dateFrom: Date | null;
  dateTo: Date | null;
  suche: string;
}

export const LEERE_FILTER: FilterZustand = {
  projectId: '',
  userId: '',
  dateFrom: null,
  dateTo: null,
  suche: ''
};

/** Frist, innerhalb der Mitarbeiter eigene Einträge ändern dürfen. */
export const BEARBEITUNGSFRIST_STUNDEN = 192;
